import React from "react";
import { StyleSheet, Text, View } from "react-native";
import { Ionicons } from "@expo/vector-icons";

import AttributeCard from "./AttributeCard";

import { type UserProfileAttributes } from "@/schemas/profile/UserProfileAttributes";
import {
  formatBody,
  formatEthnicity,
  formatHeight,
  formatWeight,
} from "@/utils/attributes";

type PersonalDetailsProps = {
  attributes: UserProfileAttributes;
};

function PhysicalAttributes({
  attributes,
}: PersonalDetailsProps): React.JSX.Element {
  const maxWidth = 25;
  const height = formatHeight(attributes.height, maxWidth);
  const weight = formatWeight(attributes.weight, maxWidth);
  const bodyType = formatBody(attributes.bodyType, maxWidth);
  const ethnicity = formatEthnicity(attributes.ethnicity, maxWidth);

  return (
    <View style={styles.container}>
      <View style={styles.sectionContainer}>
        <Ionicons name="body-outline" size={25} color="#01579b" />
        <Text style={styles.sectionTitle}>{" Physical Attributes"}</Text>
      </View>
      <View style={styles.grid}>
        <AttributeCard icon="📏" title="Height" value={height} />
        <AttributeCard icon="⚖" title="Weight" value={weight} />
        <AttributeCard icon="🏋️‍♀️" title="Body Type" value={bodyType} />
        <AttributeCard icon="🗺️" title="Ethnicity" value={ethnicity} />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: 16,
  },
  sectionContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 8,
  },
  sectionTitle: {
    fontSize: 20,
    marginLeft: 5,
    fontWeight: "bold",
  },
  grid: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
  },
});

export default PhysicalAttributes;
